import { render, staticRenderFns } from "./BodoviComponent.vue?vue&type=template&id=31361005&scoped=true&"
import script from "./BodoviComponent.vue?vue&type=script&lang=js&"
export * from "./BodoviComponent.vue?vue&type=script&lang=js&"
import style0 from "./BodoviComponent.vue?vue&type=style&index=0&id=31361005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31361005",
  null
  
)

export default component.exports